import { useTranslation } from 'react-i18next'
import { PublicPageControls } from '@/components/app/PublicPageControls'
import { StateSurface } from '@/components/app/StateSurface'

export function SessionExpiredPage() {
  const { t } = useTranslation()

  return (
    <div className="relative">
      <div className="absolute right-4 top-4 z-20 sm:right-6 sm:top-6">
        <PublicPageControls />
      </div>
      <StateSurface
        variant="fullscreen"
        size="lg"
        tone="warning"
        asset={
          <img
            src="/Uploads/session_expired.webp"
            alt={t('system.sessionExpired.title')}
            className="h-56 w-56 md:h-64 md:w-64 object-contain"
          />
        }
        title={t('system.sessionExpired.title')}
        description={t('system.sessionExpired.description')}
        primaryAction={{
          label: t('system.sessionExpired.action'),
          to: '/login',
        }}
      />
    </div>
  )
}
